import { render, staticRenderFns } from "./CallNumChartsList.vue?vue&type=template&id=5a22fba2&scoped=true&"
import script from "./CallNumChartsList.vue?vue&type=script&lang=js&"
export * from "./CallNumChartsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a22fba2",
  null
  
)

export default component.exports